/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { actualsVsPlanStatsSchema } from './actualsVsPlanStatsSchema';
import { groupedSchema } from './groupedSchema';
import { ungroupedSchema } from './ungroupedSchema';

export const actualsVsPlanBreakdownSchema = z.object({
  dimensions: z.array(z.enum(['team', 'itemType'])),
  get groups() {
    return z.array(groupedSchema);
  },
  get totals() {
    return actualsVsPlanStatsSchema;
  },
  get ungrouped() {
    return z.union([ungroupedSchema, z.null()]).optional();
  },
});
